// ipinfo.io API integration
const IPINFO_TOKEN = '8f4f6c36de8441';

// Get browser info
const getBrowserInfo = () => {
  const ua = navigator.userAgent;
  let browser = 'Unknown';
  let version = 'Unknown';
  let engine = 'Unknown';

  if (ua.indexOf('Chrome') > -1) {
    browser = 'Chrome';
    version = ua.match(/Chrome\/(\d+\.\d+\.\d+)/)?.[1] || 'Unknown';
    engine = 'Blink';
  } else if (ua.indexOf('Safari') > -1) {
    browser = 'Safari';
    version = ua.match(/Version\/(\d+\.\d+)/)?.[1] || 'Unknown';
    engine = 'WebKit';
  } else if (ua.indexOf('Firefox') > -1) {
    browser = 'Firefox';
    version = ua.match(/Firefox\/(\d+\.\d+)/)?.[1] || 'Unknown';
    engine = 'Gecko';
  } else if (ua.indexOf('Edge') > -1) {
    browser = 'Edge';
    version = ua.match(/Edge\/(\d+\.\d+)/)?.[1] || 'Unknown';
    engine = 'Blink';
  }

  return { browser, version, engine };
};

// Get device info
const getDeviceInfo = () => {
  const ua = navigator.userAgent;
  let type = 'Desktop';
  let os = 'Unknown';
  let cpu = 'Unknown';

  // Device type
  if (/mobile/i.test(ua)) {
    type = 'Mobile';
  } else if (/tablet/i.test(ua)) {
    type = 'Tablet';
  }

  // OS Detection
  if (ua.indexOf('Win') > -1) os = 'Windows 10.0';
  else if (ua.indexOf('Mac') > -1) os = 'macOS';
  else if (ua.indexOf('Linux') > -1) os = 'Linux';
  else if (ua.indexOf('Android') > -1) {
    os = 'Android ' + (ua.match(/Android (\d+\.\d+)/)?.[1] || '');
    type = 'Mobile';
  } else if (ua.indexOf('iOS') > -1) {
    os = 'iOS ' + (ua.match(/OS (\d+_\d+)/)?.[1]?.replace('_', '.') || '');
    type = 'Mobile';
  }

  // CPU Architecture
  if (ua.indexOf('x64') > -1 || ua.indexOf('x86_64') > -1) cpu = 'x64';
  else if (ua.indexOf('ARM') > -1 || ua.indexOf('aarch') > -1) cpu = 'ARM';
  else if (ua.indexOf('x86') > -1) cpu = 'x86';

  return { type, os, cpu };
};

// Fetch location data from ipinfo.io
export const fetchLocationData = async () => {
  try {
    const response = await fetch(`https://ipinfo.io/json?token=${IPINFO_TOKEN}`);
    const data = await response.json();

    const browserInfo = getBrowserInfo();
    const deviceInfo = getDeviceInfo();

    return {
      timestamp: new Date().toISOString(),
      device: deviceInfo,
      browser: browserInfo,
      network: {
        ip: data.ip,
        hostname: data.hostname,
        city: data.city,
        region: data.region,
        country: data.country,
        loc: data.loc,
        org: data.org,
        postal: data.postal,
        timezone: data.timezone,
        // Privacy/Security flags
        hosting: data.privacy?.hosting || false,
        proxy: data.privacy?.proxy || false,
        relay: data.privacy?.relay || false,
        tor: data.privacy?.tor || false,
        vpn: data.privacy?.vpn || false
      }
    };
  } catch (error) {
    console.error('Error fetching ipinfo data:', error);
    // Return fallback data with browser/device info only
    return {
      timestamp: new Date().toISOString(),
      device: getDeviceInfo(),
      browser: getBrowserInfo(),
      network: null
    };
  }
};